import React from 'react'
import { SalesOrderProvider } from './SalesOrderContext'
import { SaleOrderScreen } from '../components/views/SaleOrderScreen'

const SalesOrderWrapperContainerScreen = () => {
  return (
    <SalesOrderProvider>
      <SaleOrderScreen/>
    </SalesOrderProvider>
  )
}

export default SalesOrderWrapperContainerScreen
